import { render, staticRenderFns } from "./AdministrativePermitsResolutionsView.vue?vue&type=template&id=2c3a515c&scoped=true"
import script from "./AdministrativePermitsResolutionsView.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsResolutionsView.vue?vue&type=script&lang=js"
import style0 from "./AdministrativePermitsResolutionsView.vue?vue&type=style&index=0&id=2c3a515c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a515c",
  null
  
)

export default component.exports